import AsyncStorage from '@react-native-async-storage/async-storage';
import {create} from 'zustand';
import {persist, createJSONStorage} from 'zustand/middleware';

interface AuthState {
  token: string;
  user: any;
  refreshingToken: boolean;
  setToken: (token: string) => void;
  clearToken: () => void;
  clearUser: () => void;
  isAuthenticated: () => boolean;
  isRefreshingToken: () => boolean;
  setIsRefresing: (refreshingToken: boolean) => void;
  defUser: (user: any) => void;
}

export const useAuthStore = create(
  persist<AuthState>(
    (set, get) => ({
      token: '',
      user: null,
      refreshingToken: false,

      setToken: (token: string) => set(() => ({token})),
      defUser: (user: any) => set(() => ({user})),

      clearToken: () => set(() => ({token: ''})),
      clearUser: () => set(() => ({user: null})),

      isAuthenticated: () => !!get().token && !!get().user,
      isRefreshingToken: () => get().refreshingToken,
      setIsRefresing: (refreshingToken: boolean) => set(() => ({refreshingToken})),
    }),
    {
      name: 'auth_store',
      storage: createJSONStorage(() => AsyncStorage),
    },
  ),
);
